export const videoDescription = {
    goals: [
        {
            text: 'Watch video in 20 minutes',
            icoClass: 'zmdi zmdi-check text-green',
        },
        {
            text: 'Finish Lecture in expected time',
            points: 0,
            pointsType: 'warning',
            icoClass: 'fa fa-exclamation text-orange',
        },
        {
            text: 'Memorize all the contents',
            points: 0,
            pointsType: 'warning',
            icoClass: 'fa fa-exclamation text-orange',
        },
        {
            text: 'Earn 80% on the quiz',
            points: 0,
            pointsType: 'warning',
            icoClass: 'fa fa-exclamation text-orange',
        },
        {
            text: 'Peer questions asked',
            points: 20,
            pointsType: 'danger',
            icoClass: 'zmdi zmdi-check text-info',
        },
    ],
    meritsEarned: 5
};


// WEBPACK FOOTER //
// ./src/data/videoDescription.js